// /src/components/ButtonBubbleMenu.js
import React, { useCallback } from 'react';
import { BubbleMenu } from '@tiptap/react';
import { sticky } from 'tippy.js'

const getRenderContainer = (editor, nodeType) => {
    if (!editor?.view) return null;

    const {
        view,
        state: {
            selection: { from },
        },
    } = editor;

    const elements = document.querySelectorAll('.has-focus');

    let element = null;
    if (elements.length > 0) {
        element = elements[elements.length - 1];
    }

    if (
        element &&
        (
            element.getAttribute?.('data-type') === nodeType ||
            element.classList?.contains(nodeType)
        )
    ) {
        return element;
    }

    const domAtPos = view.domAtPos(from);
    let container = domAtPos?.node;

    if (!container) return null;

    if (!container.tagName) {
        container = container.parentElement;
    }

    while (
        container &&
        !(
            container.getAttribute?.('data-type') === nodeType ||
            container.classList?.contains(nodeType)
        )
    ) {
        container = container.parentElement;
    }

    return container || null;
};


const TopDealBubbleMenu = ({ editor, appendTo }) => {

    const getReferenceClientRect = () => {
        const renderContainer = getRenderContainer(editor, 'columns');

        if (!renderContainer) {
            return new DOMRect(-1000, -1000, 0, 0);
        }

        return renderContainer.getBoundingClientRect();
    };

    const shouldShow = useCallback(() => {
        return editor.isActive('columns');
    }, [editor]);
    const handleThreeColumnClick = () => {
        editor.commands.setLayout('three-column');
    };
    const handleSidebarTwoColumnClick = () => {
        editor.commands.setLayout('two-column');
    };

    return (
        <BubbleMenu
            editor={editor}
            shouldShow={shouldShow}
            updateDelay={0}
            tippyOptions={{
                zIndex: 99,
                offset: [0, 8],
                popperOptions: {
                    modifiers: [{ name: 'flip', enabled: false }],
                },
                getReferenceClientRect,
                appendTo: () => appendTo?.current || document.body,
                plugins: [sticky],
                sticky: 'popper',
            }}
        >
            <div className="bubble-toggle-menu button-box image-bubble-menu column-bubble-menu">
                <div className='image-bubble-block'>
                    <button className="full-display-button" onClick={handleSidebarTwoColumnClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={editor.isActive('columns', { layout: 'two-column' }) ? '#0A0A0A' : 'currentColor'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-columns2 w-4 h-4"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M12 3v18"></path></svg>
                    </button>
                    <button className="full-display-button" onClick={handleThreeColumnClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={editor.isActive('columns', { layout: 'three-column' }) ? '#0A0A0A' : 'currentColor'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-columns3 w-4 h-4">
                            <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                            <path d="M9 3v18"></path>
                            <path d="M15 3v18"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </BubbleMenu>
    );
};

export default TopDealBubbleMenu;
